import { render, staticRenderFns } from "./NegativeRes.vue?vue&type=template&id=e7be443c&"
import script from "./NegativeRes.vue?vue&type=script&lang=js&"
export * from "./NegativeRes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports